export var tableWrap = {
  margin: '0 2em'
};
export var reportTable = function reportTable(theme) {
  return {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: theme.white,
    border: "1px solid ".concat(theme.gray100),
    '& thead': {
      backgroundColor: theme.gray50
    },
    '& thead th': {
      padding: '1em 1.5em',
      textAlign: 'left',
      fontWeight: 500,
      fontSize: '1.2rem',
      color: theme.gray300,
      borderBottom: "1px solid ".concat(theme.gray100)
    },
    '& tbody td': {
      padding: '0 1.5em',
      height: '5rem',
      fontSize: '1.3rem',
      color: theme.gray700,
      borderBottom: "1px solid ".concat(theme.gray100),
      verticalAlign: 'middle'
    },
    '& tbody tr:last-of-type td': {
      borderBottom: 'none'
    },
    '& tbody tr': {
      transition: 'background-color .2s ease-in-out'
    },
    '& tbody tr:hover': {
      backgroundColor: theme.gray50
    }
  };
};
export var reportTableRow = function reportTableRow(isOffice) {
  return function (theme) {
    return {
      backgroundColor: isOffice ? theme.gray50 : theme.white,
      '& td:last-of-type': {
        width: 1,
        whiteSpace: 'nowrap'
      }
    };
  };
};